"use strict";
/* eslint-disable @typescript-eslint/no-non-null-assertion */
// @ts-nocheck
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Farm = exports.CropDistribution = exports.Field = void 0;
const Client_1 = __importDefault(require("./Client"));
const Acreage_1 = __importDefault(require("@becrop/components/Modules/Common/Models/Acreage"));
const Crop_1 = __importDefault(require("./Crop"));
const WKT_1 = __importDefault(require("ol/format/WKT"));
const olSphere = __importStar(require("ol/sphere"));
const Utils_1 = require("@becrop/components/Map/Utils");
const axios_1 = __importDefault(require("axios"));
const ColorLibController_1 = __importDefault(require("@becrop/components/Results/Abstract/Controllers/ColorLibController"));
const Tabular_1 = require("./Tabular");
const colorController = new ColorLibController_1.default();
class Field {
    constructor(obj) {
        var _a, _b, _c;
        this.areaID = obj.areaID || -1;
        this.id = obj.id || -1;
        this.gis_field_id = obj.gis_field_id || -1;
        this.name = obj.name || '#Field';
        this.farmName = obj.farm || '#Farm';
        this.client = obj.client || new Client_1.default({});
        this.polygon = obj.polygon || '-';
        this.samples = obj.samples || new Array();
        this.crop = obj.crop || new Crop_1.default({});
        this.hasResults = obj.hasResults || false;
        this.acreage = obj.acreage || new Acreage_1.default(-1, '');
        this.positionCheck = obj.positionCheck || false,
            this.eBeCropDiagnostic = { acreage: ((_a = obj.diagnostic) === null || _a === void 0 ? void 0 : _a.acreage) || false, region: ((_b = obj.diagnostic) === null || _b === void 0 ? void 0 : _b.region) || false, crop: ((_c = obj.diagnostic) === null || _c === void 0 ? void 0 : _c.crop) || false };
        this.recomendationsBrief = obj.recomendationsBrief || 'no_recomendations';
        this.recomendationsAvailability = obj.recomendationsAvailability || '';
        this.metrics = obj.metrics || [];
        this.needMaps = obj.needMaps || [];
        this.updateSize();
    }
    get calculatedAcreage() {
        // Crear acreage 
    }
    get areaName() {
        if (this.name.includes('')) {
            return this.name.split(' - ')[0];
        }
        return this.name;
    }
    get fieldName() {
        if (this.name.includes('')) {
            return this.name.split(' - ')[1];
        }
        return this.name;
    }
    get sampleCodes() {
        return this.samples.map((s) => s.code);
    }
    get bioMetrics() {
        return this.metrics.filter(m => m).filter((m) => 'category' in m);
    }
    get phchMetrics() {
        return this.metrics.filter(m => m).filter((m) => 'visual' in m);
    }
    updateSize() {
        if (this.polygon.length > 1) {
            let extension = (0, Utils_1.getExtension)(this.polygon);
            this.acreage = new Acreage_1.default(Math.round((extension / 10000) * 100) / 100, 'hectareas');
        }
    }
    /*     const config = {
                tiffUrl: this.tiffUrl,
                isNeedMaps: this.isNeedMaps,
                needMap: this.getCurrentNeedMap,
                isComparison: this.isComparisonMode,
                isMainPanel: this.isMainPanel,
                dimension: this.dimension,
                bioMetric: this.currentMetric,
                phchMetric: this.currentPhChMetric,
                vsMetric: this.currentComparisonMetric,
                vsPhChMetric: this.currentComparisonPhChMetric
        } */
    findDisplayedMetric(config) {
        if (config.isComparison) {
            if (config.dimension === 'bio') {
                if (config.vsMetric.higherIn !== '-') {
                    /*                     const metric = this.bioMetrics.find((m:BioMetric) => m.code_name === config.vsMetric.baseMetric.code_name)
                                        return metric */
                    if (config.isMainPanel) {
                        if (config.vsMetric.higherIn === 'main') {
                            const metric = this.bioMetrics.find((m) => m.code_name === config.vsMetric.winnerMetric.code_name);
                            return metric;
                        }
                        if (config.vsMetric.higherIn === 'secondary') {
                            const metric = this.bioMetrics.find((m) => m.code_name === config.vsMetric.defeatedMetric.code_name);
                            return metric;
                        }
                    }
                    else {
                        if (config.vsMetric.higherIn === 'main') {
                            const metric = this.bioMetrics.find((m) => m.code_name === config.vsMetric.defeatedMetric.code_name);
                            return metric;
                        }
                        if (config.vsMetric.higherIn === 'secondary') {
                            const metric = this.bioMetrics.find((m) => m.code_name === config.vsMetric.winnerMetric.code_name);
                            return metric;
                        }
                    }
                }
            }
            else {
                if (config.vsPhChMetric.higherIn !== '-') {
                    if (config.isMainPanel) {
                        if (config.vsMetric.higherIn === 'main') {
                            const metric = this.phchMetrics.find((m) => m.code_name === config.vsMetric.winnerMetric.code_name && m.test_name === config.vsMetric.winnerMetric.test_name);
                            return metric;
                        }
                        if (config.vsMetric.higherIn === 'secondary') {
                            const metric = this.phchMetrics.find((m) => m.code_name === config.vsMetric.defeatedMetric.code_name && m.test_name === config.vsMetric.defeatedMetric.test_name);
                            return metric;
                        }
                    }
                    else {
                        if (config.vsMetric.higherIn === 'main') {
                            const metric = this.phchMetrics.find((m) => m.code_name === config.vsMetric.defeatedMetric.code_name && m.test_name === config.vsMetric.defeatedMetric.test_name);
                            return metric;
                        }
                        if (config.vsMetric.higherIn === 'secondary') {
                            const metric = this.phchMetrics.find((m) => m.code_name === config.vsMetric.winnerMetric.code_name && m.test_name === config.vsMetric.winnerMetric.test_name);
                            return metric;
                        }
                    }
                }
            }
        }
        else {
            if (config.dimension === 'bio') {
                const metric = this.bioMetrics.find((m) => m.code_name === config.bioMetric.code_name);
                return metric;
            }
            else {
                const metric = this.phchMetrics.find((m) => m.code_name === config.phchMetric.code_name && m.test_name === config.phchMetric.test_name);
                return metric;
            }
        }
    }
    strokeColor(config) {
        if (config.baseState) {
            return '#85df4f';
        }
        else {
            if (config.dimension === 'phch') {
                return '#85df4f';
            }
            else {
                if (config.isNeedMaps) {
                    const isRate = (config.needMap.category.slug === 'rate') ? true : false;
                    if (!isRate) {
                        const activeNeedMap = this.needMaps.find((nm) => nm.category.slug === config.needMap.category.slug);
                        if (activeNeedMap)
                            return colorController.darkenColor(activeNeedMap.color, 0.9);
                        return '#000000';
                    }
                    else {
                        return colorController.getCategoryColor(config.needMap.category.title);
                        return '#000000';
                    }
                }
                else {
                    const metric = this.findDisplayedMetric(config);
                    if (metric)
                        return colorController.darkenColor(metric.color, 0.9);
                    return '#000000';
                }
            }
        }
    }
    fillColor(config) {
        if (config.baseState) {
            return '#85df4f20';
        }
        else {
            if (config.dimension === 'phch') {
                if (config.tiffUrl.length > 0) {
                    return '#ffffff00';
                }
                else {
                    return '#85df4f20';
                }
            }
            else {
                if (config.isNeedMaps) {
                    const isRate = (config.needMap.category.slug === 'rate') ? true : false;
                    if (!isRate) {
                        if (config.needMap.results.raster_url.length > 0) {
                            return '#ffffff00';
                        }
                        else {
                            const activeNeedMap = this.needMaps.find((nm) => nm === config.needMap);
                            if (activeNeedMap)
                                return activeNeedMap.transparency;
                            return '#00000050';
                        }
                    }
                    else {
                        return colorController.getCategoryTransparency(config.needMap.category.title);
                    }
                }
                else {
                    if (config.tiffUrl) {
                        return '#ffffff00';
                    }
                    else {
                        const metric = this.findDisplayedMetric(config);
                        if (metric)
                            return metric.transparency;
                        return '#00000050';
                    }
                }
            }
        }
    }
    score(config) {
        if (config.isNeedMaps) {
            const activeNeedMap = this.needMaps.find((nm) => nm === config.needMap);
            if (activeNeedMap)
                return activeNeedMap.results.stats.mean;
            return -1;
        }
        else {
            if (config.isComparison) {
                if (config.dimension === 'bio') {
                    const metric = this.findDisplayedMetric(config);
                    if (metric) {
                        if ('scoreBC' in metric) {
                            return metric.scoreBC.value;
                        }
                    }
                    return 0;
                }
                else {
                    const metric = this.findDisplayedMetric(config);
                    if (metric) {
                        return metric.score;
                    }
                    return 0;
                }
            }
            else {
                if (config.dimension === 'bio') {
                    const metric = this.findDisplayedMetric(config);
                    if (metric) {
                        if ('scoreBC' in metric) {
                            return metric.scoreBC.value;
                        }
                    }
                    return 0;
                }
                else {
                    const metric = this.findDisplayedMetric(config);
                    if (metric) {
                        return metric.score;
                    }
                    return 0;
                }
            }
        }
    }
    setAcreage(value, unit) {
        this.acreage = new Acreage_1.default(value, unit);
    }
    get getAcreage() {
        if (this.polygon.length > 5) {
            const projections = { dataProjection: 'EPSG:4326', featureProjection: 'EPSG:3857' };
            const feature = new WKT_1.default().readFeature(this.polygon, projections);
            const geometry = feature.getGeometry();
            const area = olSphere.getArea(geometry);
            return (area / 10000).toFixed(2);
        }
    }
    get region() {
        // Need to calculate the region where the polygon is located
        // Optional: Replantear la idea
        return 'midwest';
    }
    get getCrop() {
        // Need to return the crop
        return 'corn';
    }
    get meetsEBeCropConditions() {
        return this.eBeCropDiagnostic;
    }
    /*     getMetric(m:BioMetric | PhChMetric) {
            return this.metrics.find((me:BioMetric | PhChMetric) => m === me)
        } */
    /*     getMetricScore(m:string) {
            const allScoresInField = this.samples.map((s:SampleRecommendation) => s.findMetric(m))
        } */
    /*     calculateMetricValue(metric:BioMetric) {
            // Dentro de las muestras buscar
        } */
    async downloadFieldReportPDF(projectId, gisAreaId, needsAccurate, gisFieldId, fieldName) {
        (needsAccurate)
            ? await this.downloadFieldReportAccuratePDF(gisFieldId)
            : await this.downloadFieldReportBySamplesPDF(projectId, gisAreaId, fieldName);
    }
    async downloadFieldReportAccuratePDF(gisFieldId) {
        const url = '/data/results/gis-field/pdf/' + gisFieldId;
        const link = document.createElement('a');
        link.href = url;
        document.body.appendChild(link);
        window.open(url);
    }
    async downloadFieldReportBySamplesPDF(projectId, gisAreaId, fieldName) {
        const body = new FormData();
        body.set('project_id', projectId);
        body.set('gis_area_id', gisAreaId);
        this.sampleCodes.forEach((c, index) => {
            body.set(`samples[${index}]`, c);
        });
        const polygon = this.polygon;
        // @ts-ignore
        body.set('polygon', polygon);
        // @ts-ignore
        body.set('field_name', fieldName);
        const fileName = `${fieldName}_${this.areaName}_report`;
        try {
            const response = await axios_1.default.post('/data/results/field/pdf', body, {
                responseType: 'arraybuffer',
                headers: {
                    'Content-Type': 'application/json',
                    Accept: 'application/pdf',
                },
            });
            this.downloadPDF(response.data, fileName);
        }
        catch (error) {
            console.error('Error fetching or opening PDF:', error);
        }
    }
    downloadPDF(data, fileName) {
        const sanitizeFilename = (filename) => {
            filename = filename.replace(/[^\w\s]/gi, '_');
            return filename;
        };
        const newBlob = new Blob([data], { type: 'application/pdf' });
        const objUrl = window.URL.createObjectURL(newBlob);
        const link = document.createElement('a');
        link.href = objUrl;
        const sanitizedFilename = sanitizeFilename(fileName);
        link.download = `${sanitizedFilename}.pdf`;
        link.click();
        window.open(objUrl, '_blank');
        setTimeout(() => {
            window.URL.revokeObjectURL(objUrl);
        }, 250);
    }
    tabularize() {
        return new Tabular_1.FieldTabular({
            name: this.name,
            id: this.id,
            geodata: this.polygon,
            crop: this.crop,
            acreage: this.acreage,
            client: this.client,
            farm: new Tabular_1.FarmMinimal({
                name: this.farmName,
                id: this.areaID
            }),
            results: new Tabular_1.FarmReport({
                'bioMetrics': this.bioMetrics
            })
        });
    }
}
exports.Field = Field;
class CropDistribution {
    constructor(obj) {
        this.crop = obj.crop || new Crop_1.default({});
        this.acreage = obj.acreage || new Acreage_1.default(0, '');
        this.percentage = obj.percentage || -1;
    }
    addAcreage(value) {
        this.acreage.setValue(this.acreage.value + value);
    }
    setPercentage(perc) {
        this.percentage = perc;
    }
}
exports.CropDistribution = CropDistribution;
class Farm {
    constructor(obj) {
        this.name = obj.name || '#Farm';
        this.id = obj.id || -1;
        this.geodata = obj.geodata || '';
        this.fields = obj.fields || new Array();
    }
    set geodata(newGeodata) {
        if (newGeodata.length > 0)
            this.geodata = newGeodata;
    }
    get acreage() {
        if (this.fields.length > 0) {
            const acreage = this.fields.reduce((accum, f, i) => {
                accum += f.acreage.value;
            }, 0);
            return new Acreage_1.default(acreage, this.fields[0].acreage.unit);
        }
        else {
            return new Acreage_1.default(0, '');
        }
    }
    get crops() {
        return Array.from(new Set(this.fields
            .map((f) => f.crop)
            .map((obj) => JSON.stringify(obj)))).map((str) => JSON.parse(str));
    }
    get cropDistribution() {
        const crops = [];
        if (this.fields.length > 0) {
            this.fields.forEach((f) => {
                const cropIx = crops.findIndex((cd) => cd.crop.id === f.crop.id);
                if (cropIx !== -1) {
                    crops[cropIx].addAcreage(f.acreage.value);
                    crops[cropIx].percentage = crops[cropIx].acreage.value / this.acreage.value;
                }
                else {
                    crops.push(new CropDistribution({
                        'crop': f.crop,
                        'acreage': f.acreage,
                        'percentage': f.acreage.value / this.acreage.value
                    }));
                }
            });
        }
        return crops;
    }
    get numFields() {
        return this.fields.length;
    }
}
exports.Farm = Farm;
